export enum TCameraVerificationIssue {
  None,
  MissingReference,
  RejectedImage,
}

export const cameraVerificationIssueToLabel: Record<TCameraVerificationIssue, string> = {
  [TCameraVerificationIssue.None]: 'None',
  [TCameraVerificationIssue.MissingReference]: 'Has Missing Reference Images',
  [TCameraVerificationIssue.RejectedImage]: 'Has Rejected Images',
};
